// Public portfolio page (EPD-10101 / EPD-10102 / EPD-10104 / EPD-12500).
//
// /portfolio/<slug> is a creator's published portfolio. Its address is
// https://www.aspire.io/portfolio/<slug>, served from the marketing-domain
// portfolio host; on the app origin the edge 301s /portfolio/<slug> there
// (apps/web/worker.ts), so this route renders on the app origin only where no
// portfolio host is configured (local dev, preview). The earlier /p/<slug> and
// /p2/<slug> addresses redirect here (routes/p, routes/p2).
//
// Draft/live gating is enforced server-side: getPublicPortfolio returns
// NOT_FOUND for an unpublished (or non-existent) portfolio, so a Draft leaks no
// content here.

import {
  PublicPortfolioPage,
  PublicPortfolioPending,
} from "@/components/toolkit/public-portfolio-page";
import { portfolioBeforeLoad } from "@/lib/portfolio/public-page";
import { PUBLIC_PORTFOLIO_SLUG_PREFIX } from "@/lib/utils/profile-slug-redirect";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/portfolio/$profileSlug")({
  // A retired slug redirects to the current one (EPD-11640).
  beforeLoad: ({ context, params, location }) =>
    portfolioBeforeLoad({
      queryClient: context.queryClient,
      slug: params.profileSlug,
      location,
      prefix: PUBLIC_PORTFOLIO_SLUG_PREFIX,
    }),
  // Shown while beforeLoad waits on the page fetch (EPD-11640)
  pendingComponent: PublicPortfolioPending,
  component: PublicPortfolioRoute,
});

function PublicPortfolioRoute() {
  const { profileSlug } = Route.useParams();
  return <PublicPortfolioPage profileSlug={profileSlug} />;
}
